import * as Sentry from '@sentry/react';
import { PlanungImportClassesForm } from 'components/PlanungImport/forms/PlanungImportClassesForm';
import { PlanungImportEventsFormForm } from 'components/PlanungImport/forms/PlanungImportEventsForm';
import { PlanungImportLessonsForm } from 'components/PlanungImport/forms/PlanungImportLessonsForm';
import { PlanungImportSubjectsForm } from 'components/PlanungImport/forms/PlanungImportSubjectsForm';
import { useIsDesktop } from 'hooks/useIsDesktop';
import { AboutPage } from 'pages/About/AboutPage';
import { AbsencesPage } from 'pages/Absences/AbsencesPage';
import { MyAbsencesPage } from 'pages/Absences/MyAbsencesPage';
import { AbsencesAdministrationSubpage } from 'pages/Absences/subpages/AbsencesAdministrationSubpage';
import { AbsencesEvaluationClassMemberSubpage } from 'pages/Absences/subpages/AbsencesEvaluationClassMemberSubpage';
import { AbsencesEvaluationClassSubpage } from 'pages/Absences/subpages/AbsencesEvaluationClassSubpage';
import { AbsencesEvaluationSubpage } from 'pages/Absences/subpages/AbsencesEvaluationSubpage';
import { MyAbsencesSubpage } from 'pages/Absences/subpages/MyAbsencesSubpage';
import { ClassbookPage } from 'pages/Classbook/ClassbookPage';
import { CourseAdminSubpage } from 'pages/Courses/subpages/CourseAdminSubpage';
import { CoursePublicSubmissionsSubpage } from 'pages/Courses/subpages/CoursePublicSubmissionsSubpage';
import { CourseSubmissionSubpage } from 'pages/Courses/subpages/CourseSubmissionSubpage';
import { GroupsPage } from 'pages/Groups/GroupsPage';
import { GroupAppointmentsSubpage } from 'pages/Groups/subpages/GroupAppointmentsSubpage';
import { GroupWorkMaterialsSubpage } from 'pages/Groups/subpages/GroupWorkMaterialsSubpage';
import { InstitutionClassesSubpage } from 'pages/Institution/subpages/InstitutionClassesSubpage';
import { JoinPage } from 'pages/Join/JoinPage';
import { RunningBBBMeetingsSubpage } from 'pages/Meetings/subpages/RunningBBBMeetingsSubpage';
import { RunningZoomMeetingsSubpage } from 'pages/Meetings/subpages/RunningZoomMeetingsSubpage';
import { SettingsAbsencesSubpage } from 'pages/Settings/subpages/SettingsAbsencesSubpage';
import { SettingsImportPlanungSubpage } from 'pages/Settings/subpages/SettingsImportPlanungSubpage';
import { createBrowserRouter, Outlet, RouteObject, RouterProvider } from 'react-router-dom';
import { App } from './App';
import { BpAuthProvider } from './BpAuthProvider';
import { BpSubpage } from './components/BpSubpage/BpSubpage';
import { ErrorBoundary } from './components/ErrorBoundary/ErrorBoundary';
import { PlanungImportTeachersForm } from './components/PlanungImport/forms/PlanungImportTeachersForm';
import { ProcuratClasses } from './components/Procurat/ProcuratClasses';
import { ProcuratDepartments } from './components/Procurat/ProcuratDepartments';
import { ProcuratGroups } from './components/Procurat/ProcuratGroups';
import { AdminPage } from './pages/Admin/AdminPage';
import { InstitutionAdminSubpage } from './pages/Admin/subpages/InstitutionAdminSubpage';
import { OrganizationsSubpage } from './pages/Admin/subpages/OrganizationsSubpage';
import { CoursePage } from './pages/Courses/CoursePage';
import { CoursesPage } from './pages/Courses/CoursesPage';
import { CourseAppointmentsSubpage } from './pages/Courses/subpages/CourseAppointmentsSubpage';
import { CourseAssignmentSubpage } from './pages/Courses/subpages/CourseAssignmentSubpage';
import { CourseAssignmentsSubpage } from './pages/Courses/subpages/CourseAssignmentsSubpage';
import { CourseLessonsSubpage } from './pages/Courses/subpages/CourseLessonsSubpage';
import { CourseOverviewSubpage } from './pages/Courses/subpages/CourseOverviewSubpage';
import { CoursePersonsSubpage } from './pages/Courses/subpages/CoursePersonsSubpage';
import { CourseWorkMaterialsSubpage } from './pages/Courses/subpages/CourseWorkMaterialsSubpage';
import { GroupPage } from './pages/Groups/GroupPage';
import { GroupOverviewSubpage } from './pages/Groups/subpages/GroupOverviewSubpage';
import { GroupPersonsSubpage } from './pages/Groups/subpages/GroupPersonsSubpage';
import { Home } from './pages/Home/Home';
import { HomeworksPage } from './pages/Homeworks/HomeworksPage';
import { InstitutionPage } from './pages/Institution/InstitutionPage';
import { InstitutionCoursesSubpage } from './pages/Institution/subpages/InstitutionCoursesSubpage';
import { InstitutionGroupsSubpage } from './pages/Institution/subpages/InstitutionGroupsSubpage';
import { InstitutionOverviewSubpage } from './pages/Institution/subpages/InstitutionOverviewSubpage';
import { InstitutionPersonsSubpage } from './pages/Institution/subpages/InstitutionPersonsSubpage';
import { InstitutionSchoolyearsSubpage } from './pages/Institution/subpages/InstitutionSchoolyearsSubpage';
import { InstitutionSubjectsSubpage } from './pages/Institution/subpages/InstitutionSubjectsSubpage';
import { LoginPage } from './pages/Login/LoginPage';
import { MaterialArchivePage } from './pages/MaterialArchive/MaterialArchivePage';
import { MediaLibraryPage } from './pages/MediaLibrary/MediaLibraryPage';
import { MeetingsPage } from './pages/Meetings/MeetingsPage';
import { MessagesPage } from './pages/Messages/MessagesPage';
import { PageNotFoundPage } from './pages/PageNotFound/PageNotFoundPage';
import { ProfilePage } from './pages/Profile/ProfilePage';
import { SettingsPage } from './pages/Settings/SettingsPage';
import { SettingsCollaborationCoursesSubpage } from './pages/Settings/subpages/SettingsCollaborationCoursesSubpage';
import { SettingsCollaborationGroupsSubpage } from './pages/Settings/subpages/SettingsCollaborationGroupsSubpage';
import { SettingsCollaborationsSubpage } from './pages/Settings/subpages/SettingsCollaborationsSubpage';
import { SettingsOverviewSubpage } from './pages/Settings/subpages/SettingsOverviewSubpage';
import { SettingsProcuratSubpage } from './pages/Settings/subpages/SettingsProcuratSubpage';
import { SettingsThreemaSubpage } from './pages/Settings/subpages/SettingsThreemaSubpage';
import { SignupPage } from './pages/Signup/SignupPage';
import { TemplatesPage } from './pages/Templates/TemplatesPage';

let wrappedBrowserRouter;
if (import.meta.env.VITE_APP_SENTRY_DSN !== 'false') {
  wrappedBrowserRouter = Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);
} else {
  wrappedBrowserRouter = createBrowserRouter;
}

export const getRouter = (isDesktop: boolean) => {
  const routes: RouteObject[] = [
    {
      path: '/login',
      element: (
        <BpAuthProvider>
          <LoginPage />
        </BpAuthProvider>
      ),
    },
    {
      path: '/signup/:invitationToken',
      element: (
        <BpAuthProvider>
          <SignupPage />
        </BpAuthProvider>
      ),
    },
    {
      path: '/join/:conference',
      element: (
        <BpAuthProvider>
          <JoinPage />
        </BpAuthProvider>
      ),
    },
    {
      path: '/',
      Component: App,
      errorElement: <ErrorBoundary />,
      children: [
        {
          index: true,
          element: <Home />,
        },

        {
          path: 'courses',
          element: <Outlet />,
          children: [
            {
              index: true,
              element: <CoursesPage />,
            },
            {
              path: ':courseUuid',
              element: <CoursePage />,
              children: [
                {
                  index: true,
                  id: 'course-overview',
                  element: <CourseOverviewSubpage />,
                },
                {
                  path: 'lessons',
                  element: <CourseLessonsSubpage />,
                  children: [
                    {
                      path: ':teachingUnitUuid',
                      element: <CourseLessonsSubpage />,
                    },
                  ],
                },

                {
                  path: 'assignments',
                  children: [
                    {
                      index: true,
                      element: <CourseAssignmentsSubpage />,
                    },
                    {
                      path: ':assignmentUuid',
                      children: [
                        {
                          index: true,
                          element: <CourseAssignmentSubpage />,
                        },
                        {
                          path: 'submissions/:submissionUuid',
                          element: <CourseSubmissionSubpage />,
                        },
                        {
                          path: 'submissions/public',
                          element: <CoursePublicSubmissionsSubpage />,
                        },
                      ],
                    },
                  ],
                },
                {
                  path: 'workmaterials',
                  element: <Outlet />,
                  children: [
                    { index: true, element: <CourseWorkMaterialsSubpage variant={'table'} /> },
                    {
                      path: ':uuid',
                      element: <CourseWorkMaterialsSubpage variant={'view'} />,
                    },
                    {
                      path: 'add',
                      element: <CourseWorkMaterialsSubpage variant={'add'} />,
                    },
                    {
                      path: 'edit/:uuid',
                      element: <CourseWorkMaterialsSubpage variant={'edit'} />,
                    },
                  ],
                },
                {
                  path: 'appointments',
                  element: <CourseAppointmentsSubpage />,
                  children: [
                    {
                      path: ':add',
                      element: <CourseAppointmentsSubpage />,
                    },
                    {
                      path: ':edit/:uuid',
                      element: <CourseAppointmentsSubpage />,
                    },
                  ],
                },
                {
                  path: 'persons',
                  element: <CoursePersonsSubpage />,
                },
                {
                  path: 'cloud',
                  element: (
                    <BpSubpage>
                      <></>
                    </BpSubpage>
                  ),
                },
                {
                  path: 'admin',
                  element: <CourseAdminSubpage />,
                },
              ],
            },
          ],
        },

        {
          path: 'groups',
          element: <Outlet />,
          children: [
            {
              index: true,
              element: <GroupsPage />,
            },
            {
              path: ':groupUuid',
              element: <GroupPage />,
              children: [
                {
                  index: true,
                  id: 'group-overview',
                  element: <GroupOverviewSubpage />,
                },
                {
                  path: 'workmaterials',
                  element: <Outlet />,
                  children: [
                    {
                      index: true,
                      element: <GroupWorkMaterialsSubpage variant={'table'} />,
                    },
                    {
                      path: 'add',
                      element: <GroupWorkMaterialsSubpage variant={'add'} />,
                    },
                    {
                      path: ':uuid/edit',
                      element: <GroupWorkMaterialsSubpage variant={'edit'} />,
                    },
                    {
                      path: ':uuid',
                      element: <GroupWorkMaterialsSubpage variant={'detail'} />,
                    },
                  ],
                },
                {
                  path: 'appointments',
                  element: <GroupAppointmentsSubpage />,
                  children: [
                    {
                      path: ':add',
                      element: <GroupAppointmentsSubpage />,
                    },
                    {
                      path: ':edit/:uuid',
                      element: <GroupAppointmentsSubpage />,
                    },
                  ],
                },
                {
                  path: 'persons',
                  element: <GroupPersonsSubpage />,
                },
              ],
            },
          ],
        },

        {
          path: 'classbook/:dateParam?',
          element: <ClassbookPage />,
        },
        {
          path: 'homeworks/:dateParam?',
          element: <HomeworksPage />,
        },

        // Zeigt nur "Meine Abwesenheiten", falls im Abwesenheiten Menüpunkt
        // nur das erlaubt ist
        {
          path: 'my-absences',
          element: <MyAbsencesPage />,
        },

        // Zeigt Abwesenheitenbereich mit entsprechenden Unterseiten
        {
          path: 'absences',
          element: <AbsencesPage />,
          children: [
            {
              path: 'my-absences',
              element: isDesktop ? <MyAbsencesSubpage /> : <AbsencesPage />,
            },
            {
              path: 'administration',
              element: isDesktop ? <AbsencesAdministrationSubpage /> : <AbsencesPage />,
            },
            {
              path: 'evaluation',
              element: isDesktop ? <AbsencesEvaluationSubpage /> : <AbsencesPage />,
            },
          ],
        },

        {
          path: 'absences/evaluation/:classUuid',
          element: isDesktop ? <AbsencesEvaluationClassSubpage /> : <AbsencesPage />,
        },
        {
          path: 'absences/evaluation/:classUuid/:memberUuid',
          element: isDesktop ? <AbsencesEvaluationClassMemberSubpage /> : <AbsencesPage />,
        },

        {
          path: 'mediaLibrary',
          element: <MediaLibraryPage />,
        },

        {
          path: 'materialArchive',
          element: <MaterialArchivePage />,
        },

        {
          path: 'templates',
          element: <TemplatesPage />,
        },

        {
          path: 'messages',
          element: <MessagesPage />,
          children: [
            {
              path: ':roomId',
              element: <MessagesPage />,
            },
          ],
        },

        {
          path: 'meetings',
          element: <Outlet />,
          children: [
            {
              element: <MeetingsPage />,
              children: [
                {
                  index: true,
                  element: <RunningBBBMeetingsSubpage />,
                },
                {
                  path: 'zoom',
                  element: <RunningZoomMeetingsSubpage />,
                },
              ],
            },
          ],
        },

        {
          path: 'institution',
          element: <InstitutionPage />,
          children: [
            {
              index: true,
              id: 'institution-overview',
              element: <InstitutionOverviewSubpage />,
            },

            {
              path: 'persons',
              element: <InstitutionPersonsSubpage />,
            },
            {
              path: 'groups',
              element: <InstitutionGroupsSubpage />,
            },
            {
              path: 'courses',
              element: <InstitutionCoursesSubpage />,
            },
            {
              path: 'classes',
              element: <InstitutionClassesSubpage />,
            },
            {
              path: 'subjects',
              element: <InstitutionSubjectsSubpage />,
            },
            {
              path: 'schoolyears',
              element: <InstitutionSchoolyearsSubpage />,
            },
          ],
        },

        {
          path: 'settings',
          element: <SettingsPage />,
          children: [
            {
              index: true,
              id: 'settings-overview',
              element: <SettingsOverviewSubpage />,
            },
            {
              path: 'absences',
              element: <SettingsAbsencesSubpage />,
            },
            {
              path: 'collaborations',
              element: <SettingsCollaborationsSubpage />,
            },
            {
              path: 'collaboration-groups',
              element: <SettingsCollaborationGroupsSubpage />,
            },
            {
              path: 'collaboration-courses',
              element: <SettingsCollaborationCoursesSubpage />,
            },
            {
              path: 'planung',
              element: <SettingsImportPlanungSubpage />,
              children: [
                {
                  id: 'planung-teachers',
                  path: 'teachers',
                  element: <PlanungImportTeachersForm />,
                },
                {
                  id: 'planung-subjects',
                  path: 'subjects',
                  element: <PlanungImportSubjectsForm />,
                },
                {
                  id: 'planung-classes',
                  path: 'classes',
                  element: <PlanungImportClassesForm />,
                },
                {
                  id: 'planung-lessons',
                  path: 'lessons',
                  element: <PlanungImportLessonsForm />,
                },
                {
                  id: 'planung-events',
                  path: 'events',
                  element: <PlanungImportEventsFormForm />,
                },
              ],
            },
            {
              path: 'procurat',
              element: <SettingsProcuratSubpage />,
              children: [
                {
                  id: 'departments',
                  index: true,
                  element: <ProcuratDepartments />,
                },
                {
                  path: 'classes',
                  id: 'classes',
                  element: <ProcuratClasses />,
                },
                {
                  id: 'persongroups',
                  path: 'persongroups',
                  element: <ProcuratGroups />,
                },
              ],
            },
            {
              path: 'threema-work',
              element: <SettingsThreemaSubpage />,
            },
          ],
        },
        {
          path: 'profile',
          element: <ProfilePage />,
        },
        {
          path: 'admin',
          element: <AdminPage />,
          children: [
            {
              path: 'admin',
              element: <InstitutionAdminSubpage />,
            },
            {
              path: 'organizations',
              element: <OrganizationsSubpage />,
            },
          ],
        },
        {
          path: 'app-about',
          element: <AboutPage />,
        },
      ],
    },
    {
      path: 'about',
      element: <AboutPage />,
    },
    {
      path: '*',
      element: <PageNotFoundPage />,
    },
  ];
  return wrappedBrowserRouter(routes, {
    basename: import.meta.env.VITE_APP_BASEPATH,
    future: {
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_relativeSplatPath: true,
    },
  });
};

export const Router = () => {
  const isDesktop = useIsDesktop();
  return <RouterProvider router={getRouter(isDesktop)} future={{ v7_startTransition: false }} />;
};
